'use client'
import Image from 'next/image';
import styles from './page.module.css';

export default function Home() {
  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <Image
          className={styles.logo}
          src='/images/jf-logo.png'
          alt='FE logo'
          width='100'
          height='100' />
      </main>
      <footer className={styles.footer}>
      </footer>
    </div>
  );
}
